import type { SubscriptionListResponseSubscriptionsItem } from './subscriptionListResponseSubscriptionsItem';

export interface SubscriptionListResponse {
  subscriptions: SubscriptionListResponseSubscriptionsItem[];
  /** 전체 구독 수 */
  totalCount: number;
}
